import { useCallback, useSyncExternalStore } from 'react';

// No router library for three routes: `nginx.conf` already falls back every path to
// `index.html`, so a plain pathname works the same in prod as in dev.
const subscribe = (onStoreChange: () => void): (() => void) => {
  addEventListener('popstate', onStoreChange);
  return (): void => {
    removeEventListener('popstate', onStoreChange);
  };
};

const getSnapshot = (): string => location.pathname;
const getServerSnapshot = (): string => '/';

export const useRoute = (): {
  readonly path: string;
  readonly navigate: (path: string) => void;
} => {
  const path = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  const navigate = useCallback((next: string): void => {
    if (next === location.pathname) {
      return;
    }
    history.pushState({}, '', next);
    dispatchEvent(new PopStateEvent('popstate'));
  }, []);

  return { path, navigate };
};
